import formatDate from '@shared/utils/formatDate';
import { getLatest } from '@shared/v2/utils/date';

type ProcuredOffer = {
  travelDateRange: { start: { utc: string }; end: { utc: string } };
};

export const getProcuredOfferCalendarDatesMessage = (
  procuredOffer?: ProcuredOffer,
) => {
  if (!procuredOffer) {
    return undefined;
  }

  const { start, end } = procuredOffer.travelDateRange;
  const today = new Date();
  const effectiveStartDate = getLatest(start.utc, today);

  if (!effectiveStartDate) {
    return undefined;
  }

  return `Travel between ${formatDate(effectiveStartDate)} - ${formatDate(end.utc)}`;
};
